import { ApolloClient, NormalizedCacheObject, from } from '@apollo/client';
import { createBasicHttpLink, buildAuthErrorLink, getApolloDevtoolsOptions } from '@blocs.auth';
import cache from './cache';

function createApolloClient(): ApolloClient<NormalizedCacheObject> {
  return new ApolloClient({
    link: from([buildAuthErrorLink({}), createBasicHttpLink()]),
    cache,
    name: 'web',
    version: 'public-pages',
    devtools: getApolloDevtoolsOptions(),
  });
}

export default createApolloClient;
